var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStarEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-V2",
    transform: "translate(-191.000000, -1701.000000)",
    fill: "#EEEEEE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(79.500000, 1408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(20.500000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4374202,6.81303601 L80.1655833,6.53951636 L80.1655833,6.53951636 L78.5485156,2.58304945 C78.4742228,2.4012778 78.2666415,2.31414899 78.0848698,2.38844181 C77.9965069,2.42455707 77.9263775,2.49468652 77.8902622,2.58304945 L76.2731944,6.53951636 L76.2731944,6.53951636 L72.0060152,6.81303772 C71.8100494,6.8255989 71.6613707,6.99464337 71.6739318,7.19060912 C71.6802041,7.28846262 71.7266086,7.37938202 71.8021729,7.44186948 L75.0703889,10.1445011 L75.0703889,10.1445011 L73.9954346,14.2537895 C73.9457387,14.4437649 74.0594577,14.638057 74.2494331,14.6877529 C74.34332,14.7123129 74.4431661,14.6974293 74.5258083,14.6465549 L78.2193889,12.3727922 L78.2193889,12.3727922 L81.912999,14.6465588 C82.0802217,14.7495002 82.299233,14.6973899 82.4021743,14.5301673 C82.4530484,14.4475252 82.4679318,14.3476795 82.4433719,14.2537929 L81.3684167,10.1445011 L81.3684167,10.1445011 L84.6410958,7.44202764 C84.7925116,7.31699328 84.8138981,7.09288609 84.6888637,6.94147022 C84.6263686,6.86578898 84.535369,6.81930753 84.4374202,6.81303601 Z",
    id: "Path-Copy-4"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarEmpty);
export default __webpack_public_path__ + "static/media/ic_star_empty.2a3686b7.svg";
export { ForwardRef as ReactComponent };